/* The shop's crew, as the job cards name them.
 *
 * Jobs are real records now, and so is the people list under Settings — but a
 * card carries initials, and turning "DK" into "Dan Kowalski, prep hand" is a
 * lookup the board does on every render. The people list is only loaded when
 * Settings opens, so this stays until the crew arrives with the session. The
 * initials match what the seed creates.
 *
 * `ROLE_NOTE` is not fixture data at all — it is the sentence each role's rules
 * are described in, and it lives beside the people it describes. */
import type { Person, Role } from '@/types';

export const PEOPLE: Record<string, Person> = {
  JT: { name: 'Josh Tremaine', role: 'Sprayer' },
  DK: { name: 'Dan Kowalski', role: 'Prep hand' },
  ML: { name: 'Marcus Lee', role: 'Subcontractor' },
  RS: { name: 'Ryan Sheldon', role: 'Owner' },
};

/** What each role may do, in one sentence — the account menu shows this beside
 *  the role preview so the rules in IDEA.md §5 can be read, not guessed at.
 *
 *  Who is signed in is no longer fixture data: it comes from the session. */
export const ROLE_NOTE: Record<Role, string> = {
  owner: 'The owner can do everything, on any job, including money.',
  admin: 'The office can create and fix any job, whether or not they are on it.',
  staff: 'Staff can read every job but only edit the ones they are on.',
  subcontractor: 'Subcontractors see only the jobs they are on, and no customer detail.',
};
